module.exports = __webpack_public_path__ + "static/media/ep_naturalwhite.110a9bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/otherimages/ep_naturalwhite.png
// module id = 1515
// module chunks = 0